module.exports = __webpack_public_path__ + "img/logo-leroymerlin-mini.e2065675.svg";